import "@angular/platform-browser-dynamic";
import "@angular/platform-browser";
import "@angular/core";
import "@angular/http";
import "@angular/router";

import "rxjs";
import "jquery/src/jquery";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "../Content/css/agency.css";
import "../Content/css/loading.css";
import "../node_modules/primeng/resources/primeng.css";
import "../Content/css/primeng-theme/theme.css";
import "../Content/css/sidebar.css";
import "../Content/css/page.css";
import "../Content/css/site.css";
import "../app/main/systemDetailsRetriever/system-details-retriever.component.css";
import "./main/systemTypeManagement/system-type-registration.component.css";
import "./main/accessManagement/access-management.component.css";
import "./main/sentienceDeviceManager/sentience-device-manager.component.css";
import "./main/SystemServicesManager/system-service.component.css"
import "moment/moment";
import 'eonasdan-bootstrap-datetimepicker';
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "./main/systemHealthRetriever/system-health-retriever.component.css";
import "./main/customApplicationCreation/custom-application-creation.component.css";



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/vendor.ts
 **/